/**
 * Created by Andrey Popov on 16.11.20
 */

const Slider = cc.Node.extend({
    ctor: function () {
        this._super();

        this._percent = 0;
        this.percentChangeCallback = undefined;

        this._barRenderer = new cc.Scale9Sprite(bundles.slider.frames.editor_slider);
        this.addChild(this._barRenderer, -3);

        this._progressBarRenderer = new cc.Scale9Sprite(bundles.slider.frames.editor_slider);
        this._progressBarRenderer.setAnchorPoint(0, 0.5);
        this.addChild(this._progressBarRenderer, -2);

        this._slidBallRenderer = new cc.Sprite(bundles.slider.frames.editor_slider_pointer);
        this.addChild(this._slidBallRenderer, -1);

        cleverapps.pointerManager.create(this, {
            onDragStart: this._onDragStart.bind(this),
            onDragMove: this._onDragMove.bind(this),
            onDragEnd: this._onDragEnd.bind(this),
            instantDrag: true
        });
    },

    setContentSize: function (size) {
        cc.Node.prototype.setContentSize.call(this, size);

        this._updateRenderers();
    },

    _updateRenderers: function () {
        const width = this.width;
        const height = this.height;

        this._barRenderer.setContentSize(width, height);
        this._barRenderer.setPosition(width / 2, height / 2);

        const ball = this._slidBallRenderer;
        this.clickRect = cc.rect(-ball.width / 2, (height - ball.height) / 2, width + ball.width, ball.height);

        this._updatePercent();
    },

    _updatePercent: function () {
        const width = this.width;
        const height = this.height;
        const ratio = this._percent / 100;
        const progressWidth = width * ratio;

        this._progressBarRenderer.setContentSize(progressWidth, height);
        this._progressBarRenderer.setPosition(0, height / 2);

        this._slidBallRenderer.setPosition(progressWidth, height / 2);
    },

    setPercent: function (percent) {
        if (percent > 100) {
            percent = 100;
        }
        if (percent < 0) {
            percent = 0;
        }
        this._percent = percent;

        this._updatePercent();
    },

    getPercent: function () {
        return this._percent;
    },

    _getPercentFromTouch: function (touch) {
        const point = this.convertTouchToNodeSpace(touch);
        let percent = (point.x / this.width) * 100;
        if (percent < 0) {
            percent = 0;
        }
        if (percent > 100) {
            percent = 100;
        }
        return percent;
    },

    _onDragStart: function () {
        return true;
    },

    _onDragMove: function (touch) {
        const percent = this._getPercentFromTouch(touch);
        this.setPercent(percent);

        if (this.percentChangeCallback) {
            this.percentChangeCallback(this);
        }
    },

    _onDragEnd: function () {

    }
});
